module.exports = __webpack_public_path__ + "static/img/hover-iocn1.ec4ced4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn1.svg
// module id = Y2+w
// module chunks = 3